import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Layout from "../layouts/Layout";
import Organizations from "../pages/Organization/Organization";
import Users from "../pages/Users/Users";
import Subscriptions from "../pages/Subscriptions/Subscription";
import Coupons from "../pages/Coupons/Coupons";
import Plans from "../pages/Plans/Plans";
import Transactions from "../pages/Transactions/Transactions";
import CustomerDetails from "../pages/Users/pages/CustomerDetails";
import AddNewUser from "../pages/Users/pages/AddNewUser";
import AddOrganization from "../pages/Organization/AddOrganization";
import QrGenerator from "../pages/QrGenerator/QrGenerator";
import Invoice from "../pages/Plans/Invoice";
import AddPlan from "../pages/Plans/AddPlan";
import AffiliateProgram from "../pages/AffiliateProgram/AffiliateAccount";
import AffiliateTickets from "../pages/AffiliateProgram/Tickets";
import KnowledgeBase from "../pages/KnowledgeBase/KnowledgeBase";
import AffiliateAccount from "../pages/AffiliateProgram/AffiliateAccount";
import AffiliateComission from "../pages/AffiliateProgram/Comission";
import AffiliatePayout from "../pages/AffiliateProgram/Payout";
import AffiliateReport from "../pages/AffiliateProgram/Report";
import AddKnowledgeCategory from "../pages/KnowledgeBase/AddKnowledgeCategory";
import KnowledgeBaseArticals from "../pages/KnowledgeBase/KnowledgeBaseArticals";
import AddKnowledgeCategoryArtical from "../pages/KnowledgeBase/AddKnowledgeCategoryArtical";
import CommissionTier from "../pages/AffiliateProgram/CommissionTier";
import MessagingCommission from "../pages/AffiliateProgram/MessagingCommission";
import MetaPricingSync from "../pages/MetaPricingSync/MetaPricingSync";
import SubscriptionNew from "../pages/Subscriptions/SubscriptionNew";
import AffiliateDetails from "../pages/AffiliateProgram/AffiliateDetails";
import UsersNew from "../pages/Users/UsersNew";
import PaymentHistory from "../pages/PaymentHistory/PaymentHistory";
import PricingStudio from "../pages/PricingStudio/PricingStudio";
import WhiteLabel from "../pages/WhiteLabel/WhiteLabel";
import MetaPricing from "../pages/Plans/MetaPricing";
import AddOns from "../pages/Plans/AddOns";
import CapablitiesMatrix from "../pages/Plans/CapablitiesMatrix";
import UsageRestrictions from "../pages/Plans/UsageRestrictions";
import CostCalculator from "../pages/Plans/CostCalculator";
import LegacyMigration from "../pages/Plans/LegacyMigration";
// static design pages (demo data from utils/staticData until APIs exist)
import WhatsAppNumbers from "../pages/WhatsAppNumbers/WhatsAppNumbers";
import Invoices from "../pages/Invoices/Invoices";
import Wallet from "../pages/Wallet/Wallet";
import Tickets from "../pages/Tickets/Tickets";
import SystemHealth from "../pages/SystemHealth/SystemHealth";
import FeatureFlags from "../pages/FeatureFlags/FeatureFlags";
import AdminTeam from "../pages/AdminTeam/AdminTeam";
import AuditLog from "../pages/AuditLog/AuditLog";



const AppRoutes = () => {
  const isAuthenticate = localStorage.getItem("USER_TOKEN")
  return (
    <Router>
      <Routes>
        <Route path="/" element={isAuthenticate ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/" element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/organizations-partner" element={<Organizations />} />
          <Route path="/organizations-partner/edit-organization/:id" element={<AddOrganization />} />
          <Route path="/organizations-partner/add-new-organization" element={<AddOrganization />} />

          <Route path="/users" element={<Users />} />
          <Route path="/customers-and-users" element={<UsersNew />} />
          <Route path="/customers-and-users/view-user/:id" element={<CustomerDetails />} />
          <Route path="/customers-and-users/add-new-user" element={<AddNewUser />} />
          <Route path="/customers-and-users/edit-user/:id" element={<AddNewUser />} />
          {/* the Affiliates tab now shows the dashboard stats */}
          <Route path="/affiliate-program/dashboard" element={<Navigate to="/affiliate-program/account" replace />} />
          <Route path="/affiliate-program/account" element={<AffiliateAccount />} />
          <Route path="/affiliate-program/commission" element={<AffiliateComission />} />
          <Route path="/affiliate-program/commission/commission-tier" element={<CommissionTier />} />
          <Route path="/affiliate-program/commission/messaging" element={<MessagingCommission />} />
          <Route path="/affiliate-program/tickets" element={<AffiliateTickets />} />
          <Route path="/affiliate-program/payout" element={<AffiliatePayout />} />
          <Route path="/affiliate-program/report" element={<AffiliateReport />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/knowledge-base-articals/:id" element={<KnowledgeBaseArticals />} />
          <Route path="/add-knowledge-category" element={<AddKnowledgeCategory />} />
          <Route path="/add-knowledge-category-artical/:categoryId/:articalId?" element={<AddKnowledgeCategoryArtical />} />
          <Route path="/billing-subscription" element={<Subscriptions />} />
          <Route path="/subscription" element={<SubscriptionNew />} />
          <Route path="/coupons-promo" element={<Coupons />} />
          <Route path="/plans-pricing" element={<Plans />} />
          <Route path="/plan-meta-pricing" element={<MetaPricing />} />
          <Route path="/plan-add-ons" element={<AddOns />} />
          <Route path="/plan-capablities-matrix" element={<CapablitiesMatrix />} />
          <Route path="/plan-usage-restrictions" element={<UsageRestrictions />} />
          <Route path="/plan-legacy-migration" element={<LegacyMigration />} />
          <Route path="/plan-cost-calculator" element={<CostCalculator />} />
          <Route path="/add-plan" element={<AddPlan />} />
          <Route path="/add-plan/:id" element={<AddPlan />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/qr-code-generator" element={<QrGenerator />} />
          <Route path="/meta-pricing" element={<MetaPricingSync />} />
          <Route path="/meta-pricing/:userId" element={<MetaPricingSync />} />
          <Route path="/affiliate-details" element={<AffiliateDetails />} />
          <Route path="/pricing-studio" element={<PricingStudio />} />
          <Route path="/white-label" element={<WhiteLabel />} />
          <Route path="/whatsapp-numbers" element={<WhatsAppNumbers />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/system-health" element={<SystemHealth />} />
          <Route path="/feature-flags" element={<FeatureFlags />} />
          <Route path="/admin-team" element={<AdminTeam />} />
          <Route path="/audit-log" element={<AuditLog />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;


